import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Badge, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SurveySidePane from '../SurveySidePane/SurveySidePane';

const Survey = ({ offer }) => {
  const { code, name } = offer.survey;
  const { t } = useTranslation();

  const [state, setState] = useState({ isPaneOpen: false, loading: false });

  const handleClick = () => {
    setState({ ...state, loading: true })

    axios.post(`/api/v1/influencers/user_offers/apply_to_survey/${offer.survey.id}`)
      .then(({ data }) => {
        if (data.success) {
          setState({ isPaneOpen: true, loading: false })
        }
      }).catch(e => {
        setState({ ...state, loading: false })
        console.log(e)
      })
  }

  return <Container>
    <SurveySidePane
      isPaneOpen={state.isPaneOpen}
      onRequestClose={() => setState({ isPaneOpen: false })}
      typeformID={code}
    />
    <Row className="mb-5">
      <Col xs={12}>
        <h3>{t('influencers.pages.campaign.survey.title')}</h3>
      </Col>
    </Row>
    <Row className='align-items-center justify-content-between'>
      <Col className="col-auto">
        <Badge variant="warning" className='ml-0'>{t('influencers.pages.campaign.survey.incomplete')}</Badge>
        <h5>{name}</h5>
      </Col>
      <Col className="col-auto">
        <Button
          variant="dark"
          onClick={handleClick}
        >
          { state.loading
            ? <Spinner animation="border" size="sm" />
            : t('influencers.pages.campaign.survey.open')
          }
        </Button>
      </Col>
    </Row>
  </Container>;
};

Survey.propTypes = {
  offer: PropTypes.object.isRequired
};

export default Survey;
